import React from 'react';

const Preconstruction = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['calculate', 'groups', 'event', 'handshake', 'view_in_ar', 'engineering', 'architecture', 'lightbulb'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Preconstruction
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Strategic Planning for Optimal Project Success
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Preconstruction Overview */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Preconstruction Excellence</h2>
            <p>Gathering information, understanding goals, and delivering the best results</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                During the Preconstruction phase Bel-Aire Mechanical will gather as much information as possible. This enables us to better understand the design criteria and the intended building system performance requirements. With that in mind we are better able to use our many years of experience to recommend potential cost savings and performance enhancements.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                In our approach to provide pre-construction services, we involve partnering, teamwork, coordination and integration of the Owner, Design Team and Construction Manager through communication at weekly meetings.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Preconstruction Planning Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '0'}}>
                Weekly team meetings empower the team to all be on the same page, supporting each other and pulling in the same direction. We communicate with team members, vendors, suppliers and subcontractors.
              </p>
            </div>

            <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', border: '2px solid var(--accent-blue)'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                With a more complete understanding of the goals we will develop a guide for the project team in selecting methods, sequencing of processes and defining all the elements of the project. We also confirm the project scope and team responsibilities. <strong style={{color: 'var(--accent-blue)'}}>The result is getting the best product for the least amount by incorporating the project goals and objectives.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Project Teams */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Our Project Teams</h2>
            <p>Dedicated professionals committed to your success</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Project Team Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                The Bel-Aire Mechanical team embodies the capabilities that are critical for a "win-win" result for any project. Our Teams of highly skilled personnel are dedicated to their projects for the duration to ensure successful on time completion, within budget and to everyone's satisfaction.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Our Core Values</h3>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <span style={{fontSize: '1.5rem'}}>✓</span>
                    <span style={{fontSize: '1.1rem', fontWeight: '600'}}>Quality</span>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <span style={{fontSize: '1.5rem'}}>✓</span>
                    <span style={{fontSize: '1.1rem', fontWeight: '600'}}>Efficiency</span>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <span style={{fontSize: '1.5rem'}}>✓</span>
                    <span style={{fontSize: '1.1rem', fontWeight: '600'}}>Commitment</span>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <span style={{fontSize: '1.5rem'}}>✓</span>
                    <span style={{fontSize: '1.1rem', fontWeight: '600'}}>Trust</span>
                  </div>
                </div>
              </div>
              
              <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--gray-600)', marginTop: '2rem', fontStyle: 'italic'}}>
                Due to our extensive experience, we thoroughly understand the stringent requirements and rigorous standards that must be absolutely adhered to for the highest levels of quality and acceptance necessary for any project.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Preconstruction Services */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Preconstruction Services</h2>
            <p>Integrated Project Delivery for LEAN construction goals</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Team Meeting Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Our pre-construction team will attend all required meetings and provide input and feedback on budget, value engineering and performance requirements of the equipment. We recognize that <strong style={{color: 'var(--accent-blue)'}}>Integrated Project Delivery (IPD)</strong> is the most effective way to organize project teams to achieve LEAN construction goals at a time when the industry is searching for ways to eliminate waste, reduce costs, improve productivity and optimize positive outcomes.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2rem', borderRadius: '8px'}}>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  This approach integrates all team members to form a true collaborative effort.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Integrated Project Delivery (IPD) */}
      <section className="section" style={{background: 'var(--secondary-light)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Integrated Project Delivery (IPD)</h2>
            <p>Communication and Collaboration for optimal results</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Communication and Collaboration with the general contractor, architect, engineer, major building trades, subcontractors and vendors to review constructability. Everyone coming together in a collaborative environment flushing out potential issues and recognizing opportunities on the project before we begin to build it.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(0, 104, 166, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>lightbulb</span>
                  IPD Collaboration Example
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  An example of this IPD collaboration is our BIM team having hangar drawings be ready while at the same time understanding what the pour schedule is according to the master construction schedule so we can get the hangars/inserts/blue bangers ready for pour dates without interfering other trades.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [BIM/Collaboration Image]
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Design Assist / Design Build */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(171, 22, 54, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Design Assist / Design Build</h2>
            <p>Early engagement for maximum project impact</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
              <div style={{display: 'inline-block', background: 'var(--accent2-red)', color: 'var(--white)', padding: '1.5rem 3rem', borderRadius: '50px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <p style={{fontSize: '2.5rem', fontWeight: '700', margin: '0 0 0.5rem 0'}}>85%</p>
                <p style={{fontSize: '1rem', margin: 0, textTransform: 'uppercase', letterSpacing: '1px'}}>Early Design Phase Involvement</p>
              </div>
            </div>
            
            <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '2rem'}}>
              <div className="image-placeholder" style={{minHeight: '350px'}}>
                [Design Build Image]
              </div>
              
              <div>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                  On nearly 85% of our work, we are brought on board in the early design and pre-construction phase providing valuable input to assure that the project meets all of its goals. It is during this phase that the construction professional, working with the project's team, can have the most significant effect on the cost, quality and schedule of a project.
                </p>
                
                <div style={{background: 'linear-gradient(90deg, rgba(0, 104, 166, 0.1) 0%, rgba(171, 22, 54, 0.1) 100%)', padding: '2rem', borderRadius: '8px', borderLeft: '4px solid var(--accent2-red)'}}>
                  <p style={{fontSize: '1.15rem', lineHeight: '1.7', color: 'var(--primary-black)', fontWeight: '600', margin: 0}}>
                    "It is also the phase in which Bel-Aire Mechanical stands 'head and shoulders' above its competition according to our General Contractors."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 6: Assets & Perks */}
      <section className="section" style={{background: 'var(--white)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Assets & Perks</h2>
            <p>Comprehensive preconstruction capabilities and services</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '1.5rem'
            }} className="service-department-grid-2col">
              <div style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>calculate</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Estimating Materials, Means, and Methods</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>groups</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Collaboration with project owner, general, architect, and engineering</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>event</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Construction schedules and milestones</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>handshake</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Coordination with trades</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>view_in_ar</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>BIM / Autodesk-BDSU / Trimble point mapping</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>engineering</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Coordinated Construction</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>architecture</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Drawings</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>lightbulb</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Original Ideas</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>precision_manufacturing</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Design to Prefabricate</h3>
                </div>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons" style={{fontSize: '2.5rem', opacity: 0.9}}>payments</span>
                <div>
                  <h3 style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Cost Control</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Preconstruction;
